<template>
  <div class="detail">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="广告信息" name="1">
        <p class="detail-content-title pt10">发布人</p>
        <el-row class="mb20">
          <el-col :span="6">用户名：月半葵</el-col>
          <el-col :span="6">手机号：是</el-col>
          <el-col :span="6">所属代理商：106547832</el-col>
        </el-row>

        <p class="detail-content-title">基本信息</p>
        <el-form>
          <template v-if="data.adType == 'NORMAL'">
            <el-form-item label="广告标题：">
              {{data.title}}
            </el-form-item>
            <el-form-item label="封面：">
              <video v-if="data.coverType == 'VIDEO' && data.videoUrl"
                     :src="data.videoUrl"
                     width="350" height="200">
              </video>
              <show-img v-if="data.coverType == 'IMAGE' && data.videoUrl"
                        :value="data.videoUrl"
              />
            </el-form-item>
            <el-form-item label="描述：">
              <div v-html="data.description"></div>
            </el-form-item>
          </template>

          <template v-else-if="data.adType == 'GOODS'">
            <el-form-item label="商品宣传语：">
              {{data.title}}
            </el-form-item>
            <el-form-item label="商品图片：">
              <show-img class="mr10" v-for="(item,index) in data.goodsImgList" :key="index" :value="item"/>
            </el-form-item>
            <el-form-item label="商品价格：">
              {{data.goodsPrice}}
            </el-form-item>
            <el-form-item label="描述：">
              <div v-html="data.description"></div>
            </el-form-item>
          </template>

          <template v-else-if="data.adType == 'VIDEO'">
            <el-form-item label="视频宣传语：">
              {{data.title}}
            </el-form-item>
            <el-form-item label="视频：">
              <video v-if="data.videoUrl" :src="data.videoUrl" width="350" height="200"></video>
            </el-form-item>
            <el-form-item label="描述：">
              <div v-html="data.description"></div>
            </el-form-item>
          </template>

          <template v-else-if="data.adType == 'OUT_LINK'">
            <el-form-item label="广告标题：">
              {{data.title}}
            </el-form-item>
            <el-form-item label="封面：">
              <video v-if="data.coverType == 'VIDEO' && data.videoUrl"
                     :src="data.videoUrl"
                     width="350" height="200">
              </video>
              <show-img v-if="data.coverType == 'IMAGE' && data.videoUrl"
                        :value="data.videoUrl"
              />
            </el-form-item>
            <el-form-item label="广告链接：">
              {{data.outLinkUrl}}
            </el-form-item>
          </template>
        </el-form>

        <el-row class="mb20">
          创建时间：{{data.createTime}}
        </el-row>

        <el-row class="mb20">
          广告按钮： 按钮名称：{{data.buttonName}} 按钮类型：{{data.buttonType}} 按钮内容：{{data.buttonContent}}
        </el-row>

        <el-row class="mb20">
          <el-col :span="12">
            联系电话：{{data.phone}}
          </el-col>
          <el-col :span="12">
            位置信息：{{data.address}}
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="12">
            是否需要用户提交信息：{{data.visitorInfoFlag && data.visitorInfoFlag.desc}}
          </el-col>
          <el-col :span="12">
            是否开启广告评论：{{data.commentsFlag && data.commentsFlag.desc}}
          </el-col>
        </el-row>

        <p class="detail-content-title">投放信息</p>
        <el-row class="mb20">
          <el-col :span="12">
            推广区域：{{data.spreadArea}}
          </el-col>
          <el-col :span="12">
            日花费上限：{{data.dayCostLimit}}元
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="12">
            总投入上限：{{data.totalCostLimit}}元
          </el-col>
          <el-col :span="12">
            平台费用比例：{{data.platformBenefitRate}}%
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="12">
            平台费用：{{data.platformBenefit}}元
          </el-col>
          <el-col :span="12">
            广告付费方式：{{data.payType && data.payType.desc}}
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="12">
            是否在红包地图显示红包：{{data.redPacketMapFlag && data.redPacketMapFlag.desc}}
          </el-col>
          <el-col :span="12">
            红包显示位置：??
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="12">
            红包奖励规则：{{data.adRedPacketRule}}
          </el-col>
          <el-col :span="12">
            是否设置追踪广告：{{data.trackFlag && data.trackFlag.desc}}
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="12">
            期望广告投放位置：{{data.putInPosition && data.putInPosition.desc}}
          </el-col>
          <el-col :span="12">
            创建时间：{{data.createTime}}
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane label="广告数据" name="2">
        <p class="font20">广告分成：{{statistics.platformBenefit}}元</p>

        <p class="detail-content-title">投放数据</p>
        <el-row class="mb20">
          <el-col :span="8">
            广告累计支出：{{statistics.totalExpend}}
          </el-col>
          <el-col :span="8">
            累计拓客数：{{statistics.totalVisitor}}元
          </el-col>
          <el-col :span="8">
            点击数：{{statistics.totalClick}}次
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="8">
            转化率：{{statistics.conversionRate}}
          </el-col>
          <el-col :span="8">
            今日消费：{{statistics.todayExpend}}元
          </el-col>
          <el-col :span="8">
            今日拓客：{{statistics.todayVisitor}}次
          </el-col>
        </el-row>

        <p class="detail-content-title">客户数据</p>
        <div class="w500 mb20" v-for="(item, index) in statistics.visitorDataList" :key="index">
          <p class="bottom-line">{{item.createTime + '('+item.count+')'}}</p>

          <div class="disFlex" v-for="(item2, index2) in item.visitorList" :key="index2">
            <div class="flex1" :span="8" v-for="(item3,index3) in item2.visitorInfoList" :key="index3">
              {{item3.fieldName + item3.content}}
            </div>
            <div class="flex1" :span="8">
              {{item.visitorName}}
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {getAdMsg, getAdMsgStatistics} from '@/api'

  import ShowImg from '@/components/ShowImg.vue'

  export default {
    name: 'Detail',
    components: {ShowImg},
    props: ['id'],
    data () {
      return {
        activeName: '1',
        data: {},
        statistics: {
          visitorDataList: []
        }
      }
    },
    created () {
      this.getAdMsgFn()
      this.getAdMsgStatisticsFn()
    },
    watch: {
      id () {
        this.getAdMsgFn()
        this.getAdMsgStatisticsFn()
      }
    },
    methods: {
      getAdMsgFn () {
        getAdMsg(this.id).then(res => {
          this.data = res.data
        })
      },
      getAdMsgStatisticsFn () {
        getAdMsgStatistics(this.id).then(res => {
          this.statistics = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .detail {
    padding: 0 50px 50px;
  }

  .detail-content-title {
    font-size: 20px;
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .bottom-line {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

</style>
